window.onload = function() {
  console.log("gen running...");

  /*************/
  /* Home Page */
  /*************/

  /*********************/
  /* .ver-home-bundles */
  /*********************/
  // var home_bundle_imgs = [
  //   "https://cdn.shopify.com/s/files/1/0659/0785/1353/files/Air.png?v=1757958999",    // air bundle
  //   "https://cdn.shopify.com/s/files/1/0659/0785/1353/files/Water.png?v=1757958959",  // water bundle
  //   "https://cdn.shopify.com/s/files/1/0659/0785/1353/files/Earth.png?v=1757959087",  // earth bundle
  // ];
  // var home_bundle_imgs_count = 0;
  // document.querySelectorAll('.ver-home-bundles img').forEach(function(elem) {
  //   var x = setInterval(function() {
  //     elem.setAttribute("src", home_bundle_imgs[home_bundle_imgs_count]);
  //     elem.setAttribute("srcset", home_bundle_imgs[home_bundle_imgs_count]);

  //     home_bundle_imgs_count += 1;
  //     if (home_bundle_imgs_count >= home_bundle_imgs.length) {
  //       home_bundle_imgs_count = 0;
  //     }
  //   }, 5000); // update every 5 seconds
  // });

  /****************/
  /* Main Product */
  /****************/
  /*********************/
  /* .ver-main-product */
  /*********************/
  /* Buy button */
  var add_to_bag_btn = document.querySelector('.ver-main-product .product-form');
  var parent_div = add_to_bag_btn.parentElement;
  parent_div.setAttribute("id", "ver-add-btn");

  /* Accordian */
  var accordions = document.querySelectorAll('.ver-main-product .product__accordion');
  var first_accordian = accordions[0]; 
  var last_accordian = accordions[accordions.length - 1];

  first_accordian.setAttribute("id", "ver-first-accord");
  last_accordian.setAttribute("id", "ver-last-accord");
}